"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedButtonState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const react_dom_1 = require("react-dom");
const embed_1 = require("../../behavior/embed");
class EmbedButtonState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.draftUrl = ui_1.rsync.val('');
        this.draftCaption = ui_1.rsync.val('');
        this.editingPath = ui_1.rsync.val(null);
        /** Snapshot of the bounding rect of the trigger element (button or caret). */
        this.anchorRect = ui_1.rsync.val(null);
        this.normalizedDraft = ui_1.rsync.comp([this.draftUrl], ([draftUrl]) => (0, embed_1.normalizeEmbedUrl)(draftUrl));
        this.setDraftUrl = (value) => {
            this.draftUrl.set(value);
        };
        this.setDraftCaption = (value) => {
            this.draftCaption.set(value);
        };
        this.setAnchorRect = (rect) => {
            this.anchorRect.set(rect);
        };
        this.setAnchorEl = (el) => {
            this.anchorRect.set(el ? el.getBoundingClientRect() : null);
        };
        this.setAnchorFromCaret = () => {
            const rect = this.mutxt.api.focusRect();
            this.anchorRect.set(rect ?? null);
        };
        this.syncDraftFromSelection = () => {
            const entry = (0, embed_1.getActiveEmbedEntry)(this.editor);
            this.editingPath.set(entry?.[1] ?? null);
            this.draftUrl.set(entry?.[0].url ?? '');
            this.draftCaption.set(entry?.[0].caption ?? '');
        };
        this.toggle = () => {
            if (!this.canOpen.value)
                return;
            const nextOpen = !this.open.value;
            if (nextOpen) {
                this.syncDraftFromSelection();
            }
            else {
                this.editingPath.set(null);
            }
            this.open.set(nextOpen);
        };
        this.close = () => {
            this.open.set(false);
            this.editingPath.set(null);
            this.anchorRect.set(null);
            this.mutxt.api.focus();
        };
        this.apply = () => {
            const normalized = (0, embed_1.normalizeEmbedUrl)(this.draftUrl.value);
            if (!normalized)
                return;
            const editor = this.editor;
            const editingPath = this.editingPath.value;
            const caption = this.draftCaption.value.trim();
            (0, react_dom_1.flushSync)(() => this.open.set(false));
            const updated = editingPath
                ? (0, embed_1.updateEmbedAtPath)(editor, editingPath, normalized, caption)
                : !!(0, embed_1.insertEmbed)(editor, normalized, caption);
            if (!updated) {
                this.open.set(true);
                return;
            }
            this.draftUrl.set(normalized);
            this.draftCaption.set(caption);
            this.editingPath.set(null);
            this.anchorRect.set(null);
        };
        this.remove = () => {
            const editingPath = this.editingPath.value;
            if (!editingPath)
                return;
            if (!(0, embed_1.removeEmbedAtPath)(this.editor, editingPath))
                return;
            this.close();
        };
        this.editor = mutxt.editor;
        this.canOpen = ui_1.rsync.comp([mutxt.readOnly], ([readOnly]) => !readOnly);
        this.selected = ui_1.rsync.comp([mutxt.readOnly, this.open, mutxt.caretEmbedUrl], ([readOnly, open, caretEmbedUrl]) => !readOnly && (open || !!caretEmbedUrl));
    }
}
exports.EmbedButtonState = EmbedButtonState;
